import Header from "components/main/Header";
import Footer from "components/main/Footer";
import { useLocation } from "react-router-dom";

const LayoutCustom = ({ children, ...props }) => {
  const { pathname } = useLocation();

  return (
    <div className="App">
      <Header {...props} />
      <main className="bw-event-main-content">
        {children}
      </main>
      {pathname !== "/login" &&
      pathname !== "/register" &&
      pathname !== "/forgot-password" &&
      pathname !== "/reset-password" ? (
        <Footer />
      ) : null}
    </div>
  );
};

export default LayoutCustom;
